module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box",
    attrs: {
      "id": "accidentReport"
    }
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('h2', [_c('strong', [_vm._v("Accident Report Submitted")])]), _vm._v(" "), _c('h5', [_vm._v("You've submitted an accident report for accident id: "), _c('strong', [_vm._v(_vm._s(this.$props.accident.accidentId))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_c('strong', [_vm._v("We will have an agent get in contact with you on the next steps shortly. If you need to speak with one of our support specialists now, please call  1-(888)-333-4444")]), _vm._v("."), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("If this is an emergency, please call "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("911")]), _vm._v(" immediately.")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Accident Information")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Time Submitted: ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "inputPassword"
    }
  }, [_vm._v(_vm._s(this.formattedTimeSubmitted))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Accident Name: ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "inputPassword"
    }
  }, [_vm._v(_vm._s(this.$props.accident.accidentName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Vehicle Make: ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "inputPassword"
    }
  }, [_vm._v(_vm._s(this.$props.accident.vehicleMake))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Vehicle Model: ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "inputPassword"
    }
  }, [_vm._v(_vm._s(this.$props.accident.vehicleModel))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Vehicle Year: ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "inputPassword"
    }
  }, [_vm._v(_vm._s(this.$props.accident.vehicleYear))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Vehicle speed at time of impact: ")]), _vm._v(" "), (this.$props.accident.vehicleSpeed) ? _c('p', {
    attrs: {
      "id": "inputPassword"
    }
  }, [_vm._v(_vm._s(this.$props.accident.vehicleSpeed) + " MPH")]) : _c('p', {
    attrs: {
      "id": "inputPassword"
    }
  }, [_vm._v("No Value Entered")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Type of Accident: ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "inputPassword"
    }
  }, [_vm._v(_vm._s(this.$props.accident.accidentType))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Time of Accident: ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "inputPassword"
    }
  }, [_vm._v(_vm._s(this.$props.accident.accidentDate) + " " + _vm._s(this.$props.accident.accidentTime))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Location of Accident: ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "inputPassword"
    }
  }, [_vm._v(_vm._s(this.$props.accident.accidentLocation))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Additional Info: ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "inputPassword"
    }
  }, [_vm._v(_vm._s(this.$props.accident.additionalInformation))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h4', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_c('strong', [_vm._v("Services Needed ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), (this.$props.accident.servicesNeeded.length > 0) ? _c('div', _vm._l((this.$props.accident.servicesNeeded), function(service) {
    return _c('p', [_c('span', {
      staticStyle: {
        "vertical-align": "top"
      }
    }, [_vm._v(_vm._s(service) + " ")])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h4', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_c('strong', [_vm._v("Uploaded Files ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), (this.$props.accident.successfulFiles.length > 0) ? _c('div', [_c('h5', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_c('strong', [_vm._v("List of files uploaded successfully:")])]), _vm._v(" "), _vm._l((this.$props.accident.successfulFiles), function(fileObj) {
    return _c('p', [_c('i', {
      staticClass: "material-icons",
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v("check_circle")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "vertical-align": "top"
      }
    }, [_vm._v(_vm._s(fileObj.file.name))])])
  })], 2) : _vm._e(), _vm._v(" "), (this.$props.accident.unsuccessfulFiles.length > 0) ? _c('div', [_c('h5', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_c('strong', [_vm._v("List of files failed to upload:")])]), _vm._v(" "), _vm._l((this.$props.accident.unsuccessfulFiles), function(fileObj) {
    return _c('p', [_c('span', [_c('i', {
      staticClass: "material-icons",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("error")]), _vm._v(" " + _vm._s(fileObj.file.name) + " ")])])
  })], 2) : _vm._e(), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 row-block"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": _vm.submitReport
    }
  }, [_vm._v("Go Back to Main Page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_vm._v(" We will have an agent get in contact with you on the next steps shortly. If you need to speak with one of our support specialists now, please call "), _c('strong', [_vm._v("1-(888)-333-4444")]), _vm._v("."), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("If this is an emergency, please call 911 immediately.")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d7eab0fe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccidentReportSubmitted.vue
// module id = 1330
// module chunks = 2